var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{class:_vm.hiddenClass},[_vm._v(" "+_vm._s(_vm.hiddenText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }